import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const store = async (data) => {
  const url = `${window.config.ePersonamService.ePersonamHost}/${window.locale}/digital_store/store.json`;
  await apiConnector().post(url, { ...data });
};

const setListener = (selector) => {
  document.querySelector(selector).addEventListener('click', (e) => {
    const isStoreButton = e.target.classList.contains('.document_store_activator') || e.target.closest('.document_store_activator');
    if (isStoreButton) {
      const activator = e.target.classList.contains('.document_store_activator') ? e.target : e.target.closest('.document_store_activator');
      store(activator.dataset);
    }
  });
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (error) {
    errorManager(error);
  }
};

window.storeDocument = {
  init: init,
};
